const image = "_35sicomo88";

export { image };
import "./input.image.style.linaria.module.css";
//# sourceMappingURL=input.image.style.js.map
